/**
 * The printed code format (design doc, section 5.1, PROPOSED).
 *
 * Eight characters from a 30-character alphabet with no 0/O, 1/I/L or U,
 * printed as two groups: K7QM-X2RD. Case-insensitive on entry, hyphen
 * optional. The normalised code names the lobby's Durable Object, so every
 * path into a lobby must normalise the same way.
 */

export const CODE_LENGTH = 8;

/** 22 letters and 8 digits that are hard to confuse on a dark phone screen. */
export const CODE_ALPHABET = "ABCDEFGHJKMNPQRSTVWXYZ23456789";

/** Upper case, letters and digits only. Does not validate. */
export function normalizeCode(raw: string): string {
  return raw.toUpperCase().replace(/[^A-Z0-9]/g, "");
}

/** True when a normalised code has the right length and alphabet. */
export function isValidCode(code: string): boolean {
  if (code.length !== CODE_LENGTH) return false;
  for (const ch of code) {
    if (!CODE_ALPHABET.includes(ch)) return false;
  }
  return true;
}

/** K7QMX2RD → K7QM-X2RD, for display and print. */
export function formatCode(code: string): string {
  const half = CODE_LENGTH / 2;
  return `${code.slice(0, half)}-${code.slice(half)}`;
}
